import type { PerformanceResult } from "@/schemas";
import { usePerformanceQuery } from "./queries";

/**
 * Hook to fetch current portfolio performance snapshot (latest period).
 * Unlike usePortfolioData, this does NOT refetch when period changes,
 * only when selectedBookId changes.
 *
 * This is used for components that need current holdings info but don't
 * care about historical performance (e.g., UpcomingEvents, Dividends).
 */
export function useCurrentPerformance(selectedBookId: string) {
  const performanceQuery = usePerformanceQuery(selectedBookId, "max");

  return {
    performanceData: (performanceQuery.data as PerformanceResult | null) ?? null,
    loading: performanceQuery.isLoading,
  };
}
